import { useEffect, useState } from "react";
import appSettingApi from "../../api/appSetting/appSetting";
import { ui } from "../../helpers/ui";

const DEFAULTS = {
  bannerActive: false,
  bannerMessage: "",
  bannerBgColor: "#d4f0d4",
  bannerTextColor: "#2d862d",
  surveyEnabled: true,
};

const InitAdminNotificationsLogic = () => {
  const [settings, setSettings] = useState<any>(DEFAULTS);
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);
  const [pushTitle, setPushTitle] = useState<string>("");
  const [pushMessage, setPushMessage] = useState<string>("");

  const load = () => {
    setLoading(true);
    appSettingApi
      .getSettings()
      .then((response) => {
        if (response.status === 200) {
          setSettings({ ...DEFAULTS, ...response.data });
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const setField = (field: string, value: any) => {
    setSettings((prev: any) => ({ ...prev, [field]: value }));
  };

  const onSave = () => {
    setSaving(true);
    appSettingApi
      .updateSettings({
        bannerActive: settings.bannerActive,
        bannerMessage: settings.bannerMessage,
        bannerBgColor: settings.bannerBgColor,
        bannerTextColor: settings.bannerTextColor,
        surveyEnabled: settings.surveyEnabled,
      })
      .then((response) => {
        if (response.status === 200) {
          setSettings({ ...DEFAULTS, ...response.data });
          ui.alert("Podešavanja su sačuvana.");
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      })
      .finally(() => setSaving(false));
  };

  const onSendPush = () => {
    if (!pushTitle.trim() || !pushMessage.trim()) {
      ui.alert("Naslov i poruka su obavezni.");
      return;
    }
    setSending(true);
    appSettingApi
      .broadcastPush({ title: pushTitle.trim(), message: pushMessage.trim() })
      .then((response) => {
        if (response.status === 200) {
          const { sent, recipients } = response.data;
          ui.alert(`Poslato ${sent} uređaja (${recipients} klijenata).`);
          setPushTitle("");
          setPushMessage("");
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      })
      .finally(() => setSending(false));
  };

  return {
    settings,
    loading,
    saving,
    sending,
    pushTitle,
    pushMessage,
    setPushTitle,
    setPushMessage,
    setField,
    onSave,
    onSendPush,
  };
};

export default InitAdminNotificationsLogic;
